import React from 'react'
import "./css/Footer.css";
import { useStateValue } from './StateProvider'
import { auth } from "../firebase";
import { useHistory } from 'react-router-dom'

function Footer() {
  const history = useHistory();
  const [{basket, user}, dispatch] = useStateValue();

  const checkAuth = e => {
    auth.onAuthStateChanged(authUser => {
      if (authUser) {
        dispatch({
          type: 'SET_USER',
          user: authUser,
        });
        history.push('/my-account')
      } else {
        alert("You need to create an account before you can access this part")
        history.push('/register')
      }
    })
  }
  return (
    <div className="footer">
      <div className='footer-link'>
      <a href="/contact-us"><p>Have a Question, Contact Us</p></a>
      <div className='footer-links'>
        <a href='/home'>Home</a>
        <a href='/men-wears'>Men-Wears</a>
        <a href='/women-wears'>Women-Wears</a>
        <a href='/login'>Login</a>
        <a onClick={checkAuth}>My-Account</a>
        <a href='/contact-us'>Contact-Us</a>
        <a href='/'>Privacy Policy</a>
        <a href='/'>Terms & Conditions</a>
      </div>
      <hr />
    <p>Copyright 2023 <a href='/home'>Eccomerce Website</a>, All Right Reserved</p>
      </div>
    </div>

  )
}

export default Footer